module.exports = __webpack_public_path__ + "img/grupo-soles.3c335ba3.png";